import api from '@app/api'

import type { AblePaginatedResponseFn, ResponseDto } from '@app/api/dtos'
import type {
  GetListsParams,
  GetPurchasingGroupsParams,
  GetCommodityGroupsParams,
  GetCategoriesParams,
  GetSubcategoriesParams,
  GetStatusParams,
  GetConfirmedProducts,
  GetTrendsParams
} from './types'
import type {
  CatalogProductDto,
  PurchasingGroupsDto,
  CommodityGroupsDto,
  CategoriesDto,
  SubcategoriesDto,
  StatusDto,
  ConfirmedProductsDto,
  TrendsDto
} from './dtos'

const URL = '/catalog/'

const DEFAULT_PARAMS = {
  limit: 1500
}

export const getLists = async (params?: GetListsParams): Promise<ResponseDto<CatalogProductDto>> => {
  const response = await api.get<ResponseDto<CatalogProductDto>>(`${URL}products/`, { params })
  return response.data
}

export const getTrends: AblePaginatedResponseFn<GetTrendsParams, TrendsDto> = async params => {
  const url = `${URL}trends/`

  const response = await api.get(url, { params })
  return response.data
}

export const getPurchasingGroups: AblePaginatedResponseFn<
GetPurchasingGroupsParams,
PurchasingGroupsDto
> = async params => {
  const url = `${URL}purchasing-groups/`

  const response = await api.get(url, { params })
  return response.data
}

export const getCommodityGroups: AblePaginatedResponseFn<
GetCommodityGroupsParams,
CommodityGroupsDto
> = async params => {
  const url = `${URL}commodity-groups/`

  const response = await api.get(url, { params })
  return response.data
}

export const getCategories: AblePaginatedResponseFn<GetCategoriesParams, CategoriesDto> = async params => {
  const url = `${URL}categories/`

  const response = await api.get(url, { params })
  return response.data
}

export const getSubcategories: AblePaginatedResponseFn<GetSubcategoriesParams, SubcategoriesDto> = async params => {
  const url = `${URL}subcategories/`

  const response = await api.get(url, { params })
  return response.data
}

// TODO: изменить роуты, когда будет работать АПИ ?? Нужна пояснительная бригада
export const getStatus = async (params: GetStatusParams = DEFAULT_PARAMS): Promise<ResponseDto<StatusDto>> => {
  const response = await api.get<ResponseDto<StatusDto>>(`${URL}status/`, { params })
  return response.data
}

export const getConfirmedProducts = async (
  params: GetConfirmedProducts = DEFAULT_PARAMS
): Promise<ResponseDto<ConfirmedProductsDto>> => {
  const response = await api.get<ResponseDto<ConfirmedProductsDto>>(`${URL}confirmed/`, { params })
  return response.data
}
